import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import SlsInvIndexActions, { SlsInvIndexTypes } from '../Stores/SlsInvIndex/Actions';

const getAppStore = state => state.app;

export function* slsInvIndexFetchSlsInvIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(SlsInvIndexActions.slsInvIndexFetchSlsInvIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `slsInv/index/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        SlsInvIndexActions.slsInvIndexFetchSlsInvIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(SlsInvIndexActions.slsInvIndexFetchSlsInvIndexLoading(false));
  }
}

export function* slsInvIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/slsInvDetail/update/${hdrId}`));
}

export function* slsInvIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/SLS_INV/${hdrId}/SlsInvHdr`));
}

export function* slsInvIndexResetSlsInvSync01({ hdrIds }) {
  try {
    yield put(SlsInvIndexActions.slsInvIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `slsInv/syncProcess/RESET_SLS_INV_SYNC_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(SlsInvIndexActions.slsInvIndexResetSlsInvSync01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(SlsInvIndexActions.slsInvIndexWorkspaceLoading(false));
  }
}

export const saga = [
  takeLatest(SlsInvIndexTypes.SLS_INV_INDEX_FETCH_SLS_INV_INDEX, slsInvIndexFetchSlsInvIndex),
  takeLatest(SlsInvIndexTypes.SLS_INV_INDEX_GO_TO_DOCUMENT, slsInvIndexGoToDocument),
  takeLatest(SlsInvIndexTypes.SLS_INV_INDEX_GO_TO_AUDIT, slsInvIndexGoToAudit),
  takeLatest(SlsInvIndexTypes.SLS_INV_INDEX_RESET_SLS_INV_SYNC01, slsInvIndexResetSlsInvSync01)
];
